<template>
  <b-modal
    id="page-location-card-modal"
    :ok-title="trans(block && block.id ? 'save' : 'create')"
    :ok-disabled="!location_id"
    :cancel-title="trans('cancel')"
    size="lg"
    no-enforce-focus
    @shown="onShown"
    @hidden="shown = false"
    @ok="onSave"
  >
    <template v-slot:modal-title>
      <span>{{ trans('location') }}</span>
      <small v-if="!!block" class="text-muted ml-2">
        #{{ block.id }}
      </small>
    </template>

    <b-row>
      <b-col class="col-12 col-lg-8">
        <b-tabs v-model="tab" content-class="mt-3">
          <b-tab :title="trans('location')">
            <b-form-group>
              <locations-dropdown
                :organization="organization"
                type="location"
                v-model="location_id"
                icon="map-marker"
                only-with-address
                @location="onSelectLocation"
              ></locations-dropdown>
              <b-form-text>
                {{ trans('locations_only_with_address')}}
              </b-form-text>
            </b-form-group>

            <b-form-group v-if="showImageOption" :label="trans('image')">
              <b-form-radio-group v-model="image_option" :options="imageOptions" @change="onChangeImageOption"></b-form-radio-group>
            </b-form-group>

            <b-form-group :label="trans('width')">
              <b-form-radio-group v-model="image_percent" :options="image_percent_options" />
            </b-form-group>

            <b-form-group :label="trans('position')">
              <b-form-radio-group v-model="span_row">
                <b-form-radio :value="false">
                  {{ trans('inline') }}
                </b-form-radio>
                <b-form-radio :value="true">
                  {{ trans('span_row') }}
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group v-if="span_row" :label="trans('align')">
              <b-form-radio-group v-model="h_align" :options="hAlignOptions"></b-form-radio-group>
            </b-form-group>
          </b-tab>
          <b-tab :title="trans('text')">
            <b-form-group>
              <html-textarea
                :organization="organization"
                v-model="text"
                for-microsite
                show-insert-form-document
              ></html-textarea>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col class="col-6 col-lg-4">
        <page-card-block
          :block="serializedForPreview"
        ></page-card-block>
      </b-col>
    </b-row>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import LocationsDropdown from './../location/LocationsDropdown'
  import HtmlTextarea from './../../../common/components/HtmlTextarea'
  import PageCardBlock from './PageCardBlock'

  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      after: Number,
    },
    components: {
      LocationsDropdown,
      HtmlTextarea,
      PageCardBlock,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        shown: false,
        tab: 0,
        text: null,
        image_percent: 0.3333,
        image_percent_options: [
          {text: '25%', value: 0.25},
          {text: '33%', value: 0.3333},
          {text: '50%', value: 0.5},
          {text: '66%', value: 0.6666},
          {text: '75%', value: 0.75},
          {text: '100%', value: 1.0},
        ],
        span_row: false,
        h_align: 'center',
        hAlignOptions: [
          {value: 'left', text: trans('left')},
          {value: 'center', text: trans('center')},
          {value: 'right', text: trans('right')},
        ],
        location_id: null,
        location: null,
        button_url: null, // location.map_url
        image_url: null, // location.map_image_url
        imageOptions: [
          {value: 'map', text: trans('show_map')},
          {value: 'image', text: trans('image')},
        ],
        image_option: 'map',
      }
    },
    computed: {
      serialized() {
        return {
          type: 'location-card',
          text: this.text,
          location_id: this.location_id,
          button_text: 'Google Maps',
          button_url: this.button_url,
          button_target: '_blank',
          image_url: this.image_url,
          image_percent: this.image_percent,
          span_row: this.span_row,
          h_align: this.h_align,
          after: this.after,
        }
      },
      serializedForPreview() {
        return _.assign({}, this.serialized, {span_row: false})
      },
      showImageOption() {
        return !!this.location && !!this.location.image_url && !!this.location.map_image_url
      },
    },
    methods: {
      onChangeImageOption(value) {
        if (value == 'image') {
          this.image_url = this.location.image_url
        } else {
          this.image_url = this.location.map_image_url
        }
      },
      onSelectLocation(location, context) {
        this.location = location
        if (!location) {
          this.image_url = null
          this.image_option = 'map'
          this.button_url = null
          this.text = null
        } else {
          this.image_url = location.image_url || location.map_image_url
          this.image_option = this.image_url == this.location.image_url ? 'image' : 'map'
          this.button_url = location.map_url
          this.text = `<h5 style="text-align:center;">${location.name}</h5><p style="text-align:center;">${location.address}</p>`
        }
      },
      onShown() {
        this.busy = false
        this.error = null
        this.text = this.block ? this.block.text : null
        this.location_id = this.block ? this.block.location_id : null
        this.button_url = this.block ? this.block.button_url : null
        this.image_url = this.block ? this.block.image_url : null
        this.image_percent = this.block ? this.block.image_percent : 0.3333
        this.span_row = this.block ? this.block.span_row || false : false
        this.h_align = this.block ? this.block.h_align || 'center' : 'center'
        this.shown = true
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
        if (this.block && this.block.id) url += `/${this.block.id}`
        axios[this.block && this.block.id ? 'patch' : 'post'](url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide('page-location-card-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.pageLocationCardModal = this
    },
  }
</script>